import { render, staticRenderFns } from "./contract-transfer-data-nl.vue?vue&type=template&id=1efcb0de&scoped=true"
import script from "./contract-transfer-data-nl.vue?vue&type=script&lang=js"
export * from "./contract-transfer-data-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=1efcb0de&prod&scoped=true&lang=css&external"
import style1 from "./contract-transfer-data-nl.vue?vue&type=style&index=1&id=1efcb0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efcb0de",
  null
  
)

export default component.exports